import styles from "./styles.mobile.module.scss";
import { ReactNode } from "react";
import classNames from "classnames";
import { WebSearchBar } from "../../CustomComponents/WebSearchBar";
import { FacilitySelector } from "../../CustomComponents/FacilitySelector";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import {
  amplifyProvider,
  clinicController,
  localStorageProvider,
  watchlistController,
  patientController,
  timeProvider,
  notificationController,
  authController,
  homeHealthController,
  summaryController,
  circadiaEngineProvider,
  smsController,
  userController,
} from "../../../AppController";
import { useRouterHook } from "../../../hooks/useRouterHook";
import { appNotification } from "../../../util/appNotification";
import { isPIN } from "../../../util/pin";
import { setDashboardOutdateTabsAll } from "../../../redux/Dashboard/dashboard.slice";
import { useVitalsAIMode } from "../../../hooks/useVitalsAIMode";
import { isHomeHealthExternalUser } from "../../../constants/sso";

export interface IProps {
  menuIcon?: ReactNode;
  onClickSearch: () => void;
  title?: string;
  hideFacilitySelector?: boolean;
}

export const HeaderWeb: FC<IProps> = ({
  onClickSearch,
  menuIcon,
  title,
  hideFacilitySelector = false,
}) => {
  const isVitalsAIMode = useVitalsAIMode();
  const { clinicList, userClinic, user } = useAppSelector((state) => ({
    clinicList: state.clinic.clinicList,
    userClinic: state.clinic.userClinic,
    user: state.auth.user,
  }));

  const { populateAppData } = useRouterHook({
    amplifyProvider: amplifyProvider,
    authController: authController,
    clinicController: clinicController,
    localStorageProvider: localStorageProvider,
    notificationController: notificationController,
    watchlistController: watchlistController,
    timeProvider: timeProvider,
    appNotification: appNotification,
    patientController: patientController,
    circadiaEngineProvider: circadiaEngineProvider,
    summaryController: summaryController,
    homeHealthController: homeHealthController,
    isPIN: isPIN,
    smsController: smsController,
    userController: userController,
  });

  const dispatch = useAppDispatch();
  const { notificationSettings } = useAppSelector((state) => ({
    notificationSettings: state.settings.notifications,
  }));

  const isHomeHealthExternal = isHomeHealthExternalUser(user?.groups);

  const isCircadia = circadiaEngineProvider.isWindowCircadia();
  const isAndroid = circadiaEngineProvider.plat === "android";

  const changeFacility = async (clinicId: number) => {
    const selectedClinic = await clinicController.setSelectedClinic({
      id: clinicId,
      clinicList,
      notificationSettings: {
        email: notificationSettings?.email || false,
        pushNotification: notificationSettings?.pushNotification || false,
        kioskMode: notificationSettings?.kioskMode || false,
        escalatedAlertPreference:
          notificationSettings?.escalatedAlertPreference || [],
        facilitiesToSendNotificationForOldId: [clinicId],
        psnAlertPreference: notificationSettings?.psnAlertPreference || [],
        bedExitPreference: notificationSettings?.bedExitPreference || [],
        sms: notificationSettings?.sms || false,
        smsPreferences: notificationSettings?.smsPreferences || {
          morning_report: false,
          afternoon_report: false,
          evening_report: false,
          just_in_time: false,
        },
      },
    });
    if (selectedClinic) {
      localStorageProvider.remove("dashboard_filters");
      if (isCircadia && isAndroid) {
        dispatch(setDashboardOutdateTabsAll());
        populateAppData(true);
      } else {
        window.location.reload();
      }
    }
  };
  return (
    <>
      <div className={styles.container}>
        {!isVitalsAIMode && !isHomeHealthExternal ? (
          <div className={classNames(styles.searchBarCon)}>
            <div className={styles.searchCon} id="global-search">
              <WebSearchBar onSearchClick={onClickSearch} />
            </div>
          </div>
        ) : (
          // Show only the menu icon when in vitals AI mode
          <div className={classNames(styles.searchBarCon)}>
            <div className={styles.searchCon}>{menuIcon}</div>
          </div>
        )}
        {!hideFacilitySelector && (
          <div className={classNames(styles.searchBarCon)}>
            <div className={styles.searchCon} id="global-search">
              <FacilitySelector
                clinicList={clinicList}
                selectedClinic={userClinic}
                onFacilityChange={changeFacility}
              />
            </div>
          </div>
        )}
        {!isVitalsAIMode && !isHomeHealthExternal && menuIcon && (
          <div className="d-flex align-items-center">{menuIcon}</div>
        )}
      </div>
      {title && (
        <h5 className={styles.heading} id="main-heading">
          {title}
        </h5>
      )}
    </>
  );
};
